import axios from 'axios'

export const register = (data) => axios.post('/boracay/api/member/create', data).then(
    r => r.data
)
export const login = (data) => axios.post('/boracay/api/member/login', data).then(
    r => r.data
)
export const transfer = (data) => axios.post('/boracay/api/nofreemember/transferBalance', data).then(
    r => r.data
)
export const balanceQuery = (data) => axios.post('/boracay/api/nofreemember/balanceQuery', data).then(
    r => r.data
)
